var _defs, _g, _g2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEmployeeSearch(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    "data-name": "Layer 2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 300 150",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #7da267;\n      }\n\n      .cls-2 {\n        opacity: .7;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "cls-2"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M124.44,75c8.07,0,14.61-6.54,14.61-14.61s-6.54-14.61-14.61-14.61-14.61,6.54-14.61,14.61,6.54,14.61,14.61,14.61ZM119.22,80.48c-11.24,0-20.35,9.11-20.35,20.35,0,1.87,1.52,3.39,3.39,3.39h44.35c1.87,0,3.39-1.52,3.39-3.39,0-11.24-9.11-20.35-20.35-20.35h-10.43Z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 176.32,
    y: 82.68,
    width: 76.12,
    height: 28.96,
    rx: 11.2,
    ry: 11.2,
    transform: "translate(35.79 -56.15) rotate(16.26)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M115.34,24.67c-25.01,4.9-41.31,29.16-36.41,54.17,4.9,25.01,29.16,41.31,54.17,36.41,25.01-4.9,41.31-29.16,36.41-54.17-4.9-25.01-29.16-41.31-54.17-36.41ZM130.29,103.11c-17.85,3.5-35.15-8.13-38.65-25.98-3.5-17.85,8.13-35.15,25.98-38.65,17.85-3.5,35.15,8.13,38.65,25.98,3.5,17.85-8.13,35.15-25.98,38.65Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 167.22,
    y: 79.38,
    width: 14.13,
    height: 12.16,
    transform: "translate(37.1 -51.86) rotate(18.91)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmployeeSearch);
export default __webpack_public_path__ + "static/media/employee_search.e441825b37a709910218fe44f1dd15f6.svg";
export { ForwardRef as ReactComponent };